import React from 'react';
import VIPBookingSection from '../components/home/VIPBookingSection';
import SEO from '../components/SEO';
import { seoConfig } from '../config/seo';

const BookingPage = () => {
  return (
    <div className="min-h-screen bg-[#060606] pt-20" data-testid="booking-page">
      <SEO {...seoConfig.booking} />
      <VIPBookingSection fullPage />
      {/* Bottom padding for mobile bar */}
      <div className="h-20 lg:h-0" />
    </div>
  );
};

export default BookingPage;
